import { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import type AccessGroup from 'modules/core/store/models/AccessGroup'

import type { Employees } from 'modules/employees/store/collections/employees'
import { SurveyParticipantsContext } from 'modules/surveys/pages/Show/Participants/hooks'
import questionGroups from 'modules/surveys/store/collections/questionGroups'
import type { Users } from 'modules/core/store/collections/users'

interface Props {
  accessGroup: AccessGroup
  surveyId: string
  back: string
  users: Users
  employees: Employees
}

function DynamicNewRespondent({ surveyId, accessGroup, back }: Props) {
  const navigate = useNavigate()
  const { fetchRespondents } = useContext(SurveyParticipantsContext)
  const [userIds, setUserIds] = useState<string[]>([])
  const [running, setRunning] = useState(false)
  const memberIds = accessGroup.attributes.access_ids ?? []

  const onClose = () => navigate(back)

  const submit = async (closePortal: ClosePortalFn) => {
    setRunning(true)

    const { success } = await asyncAction(() =>
      questionGroups.bulkCreate({
        form_id: surveyId,
        accesses_ids: userIds,
      })
    )
    setRunning(false)

    if (success) {
      closePortal()
      fetchRespondents?.()
    }
  }

  return (
    <Modal
      title={i18n.t('surveys.form.participants.new.title')}
      description={i18n.t('surveys.form.participants.new.description.survey')}
      illustration="surveys"
      onClose={onClose}
      onSubmit={submit}
      footer={
        <Button disabled={!userIds.length || running} submit>
          {i18n.t('surveys.form.participants.new.submit')}
        </Button>
      }
    >
      <EmployeeSelectorV2
        multiple
        useAccessId
        value={userIds}
        onChange={(state) => {
          if (state.type === 'manual') {
            setUserIds(state.ids)
          }
        }}
        forcedFilters={{ excludeIds: memberIds }}
        options={{ disableSelectAll: true }}
      />
    </Modal>
  )
}

export default observer(DynamicNewRespondent)
